import { forIn } from 'lodash';
import { EntitiesManager } from './entity';
import { ComponentsManager } from './component';
import { RoutesManager } from './routes';
import { globalConfig, language } from '../services';
export * from './component';
export * from './entity';
export * from './routes';
/**
 * 配置解析
 */

function parse(config) {
  if (config.apiRoot) {
    globalConfig.set('api.root', config.apiRoot);
  }

  config = language.parse(config);
  forIn(config.entities, function (desc, name) {
    EntitiesManager.register(name, desc);
  });
  forIn(config.components, function (desc, name) {
    ComponentsManager.register(name, desc);
  });

  if (config.routes) {
    RoutesManager.register(config.routes);
  }
}

export var Parser = {
  parse: parse
};
export { ComponentsManager, EntitiesManager, RoutesManager };